import Answer from './Answer';
import Question from './Question';
import Sources from './Sources';
import Turn from './Turn';

/** One turn of the conversation: the reader's question, or the assistant's answer and its sources. */
const Message = ({ message }) => {
  if (message.role === 'user') {
    return <Question content={message.content} />;
  }

  return (
    <Turn data-testid="help-assistant-answer">
      <div className="text-foreground text-sm">
        <Answer markdown={message.content} />
      </div>
      {message.sources.length > 0 && <Sources sources={message.sources} />}
    </Turn>
  );
};

export default Message;
